import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'row']

  filter() {
    const query = this.normalize(this.inputTarget.value)

    this.rowTargets.forEach(row => {
      row.classList.toggle('hidden', !!query && !this.normalize(row.dataset.searchText).includes(query))
    })
  }

  normalize(text) {
    return (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
  }
}
